export const NOTIFICATION_ID_TO_NAME = {
  1: 'sentQuote',
  2: 'documentationOk',
};
